import { Injectable } from '@angular/core';

@Injectable()
export class IdiomaService {
  private static _instancia: IdiomaService;
  private _idioma: string;

  public static Instancia(): IdiomaService {
    if (IdiomaService._instancia == null) {
      return (IdiomaService._instancia = new IdiomaService());
    } else {
      return this._instancia;
    }
  }

  public retornaIdioma() {
    return this._idioma;
  }

  /**
   * Define idioma.
   * @param abrIdioma Abreviação do idioma. Ex.: en (inglês); pt (português); es (espanhol)
   */
  public definirIdioma(abrIdioma: string) {
    this._idioma = 'pt-br';
  }
}
export const IdiomaServico: IdiomaService = IdiomaService.Instancia();
